import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { G_SLIDER__image_brush_size } from '@/pages/page_generation/layouts/assets_images/_base/G_SLIDER__image_brush_size';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { HOOK_IMAGE__get_image_mask_for } from '@/utils/_methods/FN_IMAGE__get_image_mask_for';
import { ENUM__image_brush, ENUM_UTILS__image_brush } from '../../_base/ENUM__image_brush';

export default function G_SELECTOR__image_mask_brush() {
  const dispatch = use_dispatch();

  const { g_image_edit__field, g_image_edit__brush, g_general__ui_disabled } = use_slice_ui([
    'g_image_edit__field',
    'g_image_edit__brush',
    'g_general__ui_disabled',
  ]);

  const field_mask = HOOK_IMAGE__get_image_mask_for(g_image_edit__field);

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (field_mask.is_stub()) return;
    if (!field_mask.image__is_initialized) return;

    let { asset: image_asset } = field_mask;

    if (image_asset.is_single_color_mask) {
      dispatch(LOCAL__ui_set_string({ key: 'g_image_edit__brush', value: ENUM__image_brush.MASK_ERASER, valid_values: Object.values(ENUM__image_brush) }));
    } else if (image_asset.is_single_color_mask_empty) {
      dispatch(LOCAL__ui_set_string({ key: 'g_image_edit__brush', value: ENUM__image_brush.MASK_DRAWER, valid_values: Object.values(ENUM__image_brush) }));
    } else if (g_image_edit__brush == ENUM__image_brush.POINTER) {
      dispatch(LOCAL__ui_set_string({ key: 'g_image_edit__brush', value: ENUM__image_brush.MASK_DRAWER, valid_values: Object.values(ENUM__image_brush) }));
    }
  }, [field_mask, field_mask.asset]);
  /*
   *
   */
  function onClick(type: ENUM__image_brush) {
    dispatch(
      LOCAL__ui_set_string({
        key: 'g_image_edit__brush',
        value: type,
        valid_values: Object.values(ENUM__image_brush),
      }),
    );
  }

  /*
   * RENDER GUARD
   */
  if (field_mask.is_stub()) return <></>;
  if (!field_mask.image__is_initialized) return <></>;

  return (
    <div className="flex flex-col gap-3 bg-component p-4 rounded-lg w-full border border-border">
      {/* 1. Title Section */}
      <div className="flex items-center gap-2 text-xs font-semibold tracking-wide uppercase text-component-item-foreground">
        {ENUM_UTILS__image_brush.get_button_icon(g_image_edit__brush, 'size-3.5 text-primary')}
        <span>{g_image_edit__brush.replace('_', ' ')}</span>
      </div>

      {/* 2. Brush Selection Buttons */}
      <div className="flex items-center gap-2">
        {ENUM_UTILS__image_brush.get_brushes_mask().map(type => {
          const is_selected = g_image_edit__brush === type;

          return (
            <UI_PRIMITIVE__button
              key={type}
              aria-label={`Switch to ${type} brush`}
              disabled={g_general__ui_disabled}
              onClick={() => onClick(type)}
              variant={is_selected ? 'default' : 'no-border-on-component'}
              className={`p-2 size-9 flex-center rounded-md transition-all 
                ${is_selected ? 'pointer-events-none scale-100' : 'hover:bg-secondary/80'}`}
            >
              {ENUM_UTILS__image_brush.get_button_icon(type, 'size-4')}
            </UI_PRIMITIVE__button>
          );
        })}
      </div>

      <G_SLIDER__image_brush_size />
    </div>
  );
}
